import PARENT from '../types';

const DATASET = `${PARENT}/DATASET`;

export const SET_PAGINATION = `${DATASET}/SET_PAGINATION`;
export const SET_PAGE_INDEX = `${DATASET}/SET_PAGE_INDEX`;
export const RESET_PAGE_AND_PAGINATION = `${DATASET}/RESET_PAGE_AND_PAGINATION`;

export const SET_TYPE_OF_UPLOAD_DATASET = `${DATASET}/SET_TYPE_OF_UPLOAD_DATASET`;
export const SET_ERROR_TYPE_OF_UPLOAD_DATASET = `${DATASET}/SET_ERROR_TYPE_OF_UPLOAD_DATASET`;
export const RESET_TYPE_OF_UPLOAD_DATASET = `${DATASET}/RESET_TYPE_OF_UPLOAD_DATASET`;
